import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'; 
import { JobInterest } from './JobInterest';
import {
  getJobInterestInfo,
  getJobInfo,
  saveJobInterestInfo,
  getDeveloperInfoByJobInterestHash,
  getNotInterestedReasons,
  getDeveloperAvailabilityFromHash,
  saveAvailabilityInformationFromJobInterestForm,
  getDeveloperRateDetailsFromJobRequestForm,
  setDeveloperAvailability,
  setDeveloperExpectedRateDetails,
  saveRateChangeAttempt,
} from './job-interest/job-interest.actions';
import { loadTimezone } from './countries/countries.actions';

const mapStateToProps = (state) => {
  return {
    jobInterest: state.jobInterest.jobInterest,
    isJobInterestDetailsFetching: state.jobInterest.isJobInterestDetailsFetching,
    jobInfo: state.jobInterest.jobInfo,
    developerRateDetails: state.jobInterest.developerRateDetails,
    developerAvailability: state.jobInterest.developerAvailabilityDetail,
    developerInfo: state.jobInterest.developerInfo,
    notInterestedReasons: state.jobInterest.notInterestedReasons,
    isNotInterestedReasonsFetching: state.jobInterest.isNotInterestedReasonsFetching,
    timezones: state.countries.timezones,
    jobs: state.jobs.jobsV2
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getJobInterestInfo: (jobInterestHash) => {
      dispatch(getJobInterestInfo(jobInterestHash));
    },
    getJobInfo: (jobInterestHash) => {
      dispatch(getJobInfo(jobInterestHash));
    },
    getDeveloperAvailability: (jobInterestHash) => {
      dispatch(getDeveloperAvailabilityFromHash(jobInterestHash));
    },
    getDeveloperRateDetails: (developerId) => {
      dispatch(getDeveloperRateDetailsFromJobRequestForm(developerId));
    },
    saveJobInterestInfo: (formValues, redirectUrl) => {
      dispatch(saveJobInterestInfo(formValues, redirectUrl, true));
    },
    saveAvailabilityInformation: (hash, availabilityDetail) => {
      dispatch(saveAvailabilityInformationFromJobInterestForm(hash, availabilityDetail));
    },
    setDeveloperAvailability: (availabilityInformation) => {
      dispatch(setDeveloperAvailability(availabilityInformation));
    },
    getDeveloperInfoByJobInterestHash: (jobInterestHash) => {
      dispatch(getDeveloperInfoByJobInterestHash(jobInterestHash));
    },
    getNotInterestedReasons: () => {
      dispatch(getNotInterestedReasons());
    },
    setDeveloperExpectedRateDetails: (jobInterest) => {
      dispatch(setDeveloperExpectedRateDetails(jobInterest));
    },
    saveRateChangeAttempt: (hash, rateChange) => {
      dispatch(saveRateChangeAttempt(hash, rateChange));
    },
    getTimezones: () => dispatch(loadTimezone()),
  };
};

const connected = connect(mapStateToProps, mapDispatchToProps)(withRouter(JobInterest));

export { connected as JobInterestContainer };
